export const SET_NEW_WORKSPACE = "SET_NEW_WORKSPACE";
export const SET_TOKEN = "SET_TOKEN";
export const SET_EXTERNAL_OVERLAY = "SET_EXTERNAL_OVERLAY";
export const SET_IDS = "SET_IDS";
export const SET_ORGANIZATION_INFO = "SET_ORGANIZATION_INFO";
export const SET_ACCOUNT_INFO = "SET_ACCOUNT_INFO";
export const SET_WORKSPACE_INFO = "SET_WORKSPACE_INFO";
export const SET_INFO = "SET_INFO";
export const SET_SYSTEM_FEATURE_FLAGS = "SET_SYSTEM_FEATURE_FLAGS";
export const SET_SAVE_ERROR = "SET_SAVE_ERROR";
export const INIT_GREETING_FOR_NEW_WORKSPACE = "INIT_GREETING_FOR_NEW_WORKSPACE";

export const UPDATE_DESTINATIONS = "UPDATE_DESTINATIONS";
export const UPDATE_WORKSPACE_STATUS = "UPDATE_WORKSPACE_STATUS";
export const UPDATE_VOICE = "UPDATE_VOICE";
export const UPDATE_GREETING = "UPDATE_GREETING";
export const UPDATE_IS_CUSTOMIZED_GREETING = "UPDATE_IS_CUSTOMIZED_GREETING";
export const UPDATE_GREETING_ERROR = "UPDATE_GREETING_ERROR";
export const UPDATE_CHANNEL_ID = "UPDATE_CHANNEL_ID";
export const UPDATE_CHANNEL_ID_ERROR = "UPDATE_CHANNEL_ID_ERROR";
export const RESET_CHANNEL_ID = "RESET_CHANNEL_ID";
export const SET_VOICES = "SET_VOICES";

export const setSaveError = (saveError) => ({
  type: SET_SAVE_ERROR,
  payload: saveError,
});

export const setNewWorkspace = (newWorkspace) => ({
  type: SET_NEW_WORKSPACE,
  payload: newWorkspace,
});

export const setToken = (token, isValidToken) => ({
  type: SET_TOKEN,
  payload: { token, isValidToken },
});

export const setExternalOverlay = (externalOverlay) => ({
  type: SET_EXTERNAL_OVERLAY,
  payload: { externalOverlay },
});

export const setInfo = (info) => ({
  type: SET_INFO,
  payload: info,
});

export const setIds = (organizationId, accountId, workspaceId) => ({
  type: SET_IDS,
  payload: {
    organizationId,
    accountId,
    workspaceId,
  },
});

export const setSystemFeatureFlags = (systemFeatureFlags) => ({
  type: SET_SYSTEM_FEATURE_FLAGS,
  payload: systemFeatureFlags,
});

export const initGreetingForNewWorkspace = (greeting) => ({
  type: INIT_GREETING_FOR_NEW_WORKSPACE,
  payload: { greeting },
});

export const setOrganizationInfo = (organizationInfo) => ({
  type: SET_ORGANIZATION_INFO,
  payload: organizationInfo,
});

export const setAccountInfo = (accountInfo) => ({
  type: SET_ACCOUNT_INFO,
  payload: accountInfo,
});

export const setWorkspaceInfo = (workspaceInfo) => ({
  type: SET_WORKSPACE_INFO,
  payload: workspaceInfo,
});

export const updateDestinations = (destinations) => ({
  type: UPDATE_DESTINATIONS,
  payload: destinations,
});

export const updateWorkspaceStatus = (isEnable) => ({
  type: UPDATE_WORKSPACE_STATUS,
  payload: isEnable,
});

export const updateVoice = (updatedVoice, agentLanguage) => ({
  type: UPDATE_VOICE,
  payload: { updatedVoice, agentLanguage },
});

export const updateGreeting = (greeting) => ({
  type: UPDATE_GREETING,
  payload: greeting,
});

export const updateGreetingError = (greetingError) => ({
  type: UPDATE_GREETING_ERROR,
  payload: greetingError,
});

export const resetChannelId = () => ({
  type: RESET_CHANNEL_ID,
  payload: null,
});

export const updateChannelId = (channelId) => ({
  type: UPDATE_CHANNEL_ID,
  payload: channelId,
});

export const updateChannelIdError = (channelIdError) => ({
  type: UPDATE_CHANNEL_ID_ERROR,
  payload: channelIdError,
});

export const setVoices = (voices) => ({
  type: SET_VOICES,
  payload: voices,
});
